import { render, staticRenderFns } from "./Vivo+.vue?vue&type=template&id=9c5d0e1a"
import script from "./Vivo+.vue?vue&type=script&lang=js"
export * from "./Vivo+.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports